"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.KEY_CODES = void 0;
var KEY_CODES = {
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39
};
exports.KEY_CODES = KEY_CODES;
var _default = {
  KEY_CODES: KEY_CODES
};
exports["default"] = _default;